import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HowItFitsTogether() {
    return (
        <OnboardingBody title={<span>How it all fits together</span>}>
            <div>
                <p>
                    All outreach gets sent to an audience — that’s all broadcasts, newsletters, and
                    drip sequences.
                    <br />
                    <br />
                    Once an audience receives your message, you can view reports on important
                    metrics like open, click, unsubscribe, and bounce rates.
                </p>
            </div>
        </OnboardingBody>
    );
}
